var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!!_vm.saleClass)?_c('i',{staticClass:"i-ticket",class:_vm.saleClass}):_vm._e(),(_vm.isSeatSelectable)?_c('i',{staticClass:"i-ticket i-ticket-select"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }